export default "__VITE_ASSET__DSvPbuxL__"